import React, { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { prjDeptHeaderTyps } from '../../utils/forecastStaticData';
import ProjectDeptStateRows from './ProjectDeptStateRows';

const useStyles = makeStyles({
  table: {
    '& .MuiTableCell-root': {
      border: '1px solid rgba(224, 224, 224, 1)',
      align: 'center',
    },
  },
});

const ProjectDeptStateTable = ({ headerRows, data, tableRef }) => {
  const classes = useStyles();

  if (!headerRows || !data) {
    return null;
  }

  return (
    <Paper sx={{ overflow: 'auto', my: 1 }}>
      <TableContainer
        sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}
      >
        <Table size="small" className={classes.table} ref={tableRef}>
          <TableHead>
            <TableRow>
              <TableCell align="center" rowSpan={2}>
                본부
              </TableCell>
              <TableCell align="center" rowSpan={2}>
                팀
              </TableCell>
              {headerRows.map((header) => (
                <TableCell colSpan={2} align="center" key={header.val}>
                  {header.id === 'ES' ? `${header.name}` : `${header.name}`}
                </TableCell>
              ))}
            </TableRow>
            <TableRow>
              {headerRows.map((header) => {
                return prjDeptHeaderTyps.map((typ, index) => (
                  <TableCell align="center" key={index}>
                    {typ.name}
                  </TableCell>
                ));
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(data) && data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  데이터가 없습니다.
                </TableCell>
              </TableRow>
            ) : (
              <ProjectDeptStateRows headerRows={headerRows} data={data} />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default ProjectDeptStateTable;
